import { faExclamationCircle } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { findByAltText } from "@testing-library/react";
import { Field, FieldArray, Form, Formik } from "formik";
import { get } from "lodash";
import React, { useState } from "react";
import {
  FLOW_TYPES,
  clearFieldValues,
  formFields,
  manageFeeFormNames,
} from "../../utils";
import {
  FieldButtonGroup,
  FieldDropSide,
  FieldInput,
  FieldInputBasisPoint,
  FieldInputDollar,
  FieldInputNumber,
  FieldInputPercentage,
  FieldTextarea,
} from "../Forms";
import SearchableList from "../SearchableList";
import TieredFeesTable from "./TieredFeesTable";

const feeTypeOptions = [
  {
    label: "Balance based",
    value: 1,
  },
  {
    label: "Investment based",
    value: 2,
  },
];
const feeTypeEnum = {
  BalanceBased: 1,
  InvestmentBased: 2,
};
const allocationTypeOptions = [
  {
    label: "Fixed Amount",
    value: 1,
  },
  {
    label: "Percentage / Basis Points",
    value: 2,
  },
  {
    label: "Tiered",
    value: 3,
  },
];
const allocationTypeEnum = {
  FixedAmount: 1,
  Percentage: 2,
  Tiered: 3,
};

const allocationSubTypeOptionsPercentage = [
  {
    label: "Based on Participant Account Balance",
    value: 1,
  },
  {
    label: "Based on Plan Balance",
    value: 2,
  },
];
const allocationSubTypeOptionsPercentageInvestmentBased = [
  {
    label: "Investment Based",
    value: 3,
  },
];
const formulaTypeOptions = [
  {
    label: "Percentage",
    value: 1,
  },
  {
    label: "Basis Points",
    value: 2,
  },
];

const tierComputationTypeOptions = [
  {
    label: "Step Rate",
    value: 1,
  },
  {
    label: "Exclusive",
    value: 2,
  },
];
const tierComputationSubTypeOptions = [
  {
    label: "Fixed Amount",
    value: 1,
  },
  {
    label: "Percentage / Basis Points",
    value: 2,
  },
];

const participantAllocationOptions = [
  {
    label: "Prorated",
    value: 1,
  },
  {
    label: "Equal",
    value: 2,
  },
];
const yesNoOptions = [
  {
    label: "Yes",
    value: 1,
  },
  {
    label: "No",
    value: 2,
  },
];

function BalanceAndInvestmentBasedComponent(props) {
  const {
    values,
    setFieldValue,
    fields,
    handleChange,
    setValues,
    isEdit,
    isSave,
    showErr,
  } = props;
  console.log("values", values, isEdit, isSave);
  const isBalanceBased = values[fields.feeType] === feeTypeEnum.BalanceBased;
  const [isHovering, setIsHovering] = useState(false);

  const handleMouseOver = () => {
    setIsHovering(true);
  };

  const handleMouseOut = () => {
    setIsHovering(false);
  };

  const onAllocationTypeChange = (value) => {
    const tempValues = clearFieldValues({
      values,
      fieldsToClear: [
        fields.allocationType,
        fields.allocationSubType,
        fields.participantAllocation,
        fields.tierComputationType,
        fields.tierBasis,
        fields.feePercentageOrBasisPoints,
        fields.feeAmount,
        fields.tierComputationSubType,
        fields.formulaType,
      ],
    });
    tempValues[fields.allocationType] = value;
    if (value === 3) {
      tempValues[fields.feeTiers] = [
        {
          from: "",
          to: "",
          percentageOrAmountOrBasisPoints: "",
          isEditMode: true,
        },
      ];
    }
    setValues(tempValues);
    values.feeType == 2 &&
      (value == 1 || value == 2) &&
      setFieldValue(fields.allocationSubType, 3);
  };
  return (
    <>
      <Field
        isRequired
        name={fields.allocationType}
        label="Allocation Type"
        noLabelTransform
        autoComplete="off"
        selectedValue={values[fields.allocationType]}
        onChange={onAllocationTypeChange}
        options={allocationTypeOptions.filter((x) =>
          isBalanceBased ? true : x.value !== allocationTypeEnum.Tiered
        )}
        component={FieldButtonGroup}
        disabled={isEdit && !isSave}
        size="md"
      />

      {values[fields.allocationType] === 2 && (
        <Field
          isRequired
          name={fields.formulaType}
          noLabelTransform
          label="Percentage / Basis Points"
          autoComplete="off"
          selectedValue={values[fields.formulaType]}
          onChange={(value) => setFieldValue(fields.formulaType, value)}
          options={formulaTypeOptions}
          disabled={isEdit && !isSave}
          component={FieldButtonGroup}
          size="md"
          // validate={(value) => {
          //   return [undefined, null, ""].includes(value)
          //     ? "Required"
          //     : undefined;
          // }}
        />
      )}

      {[allocationTypeEnum.FixedAmount, allocationTypeEnum.Percentage].includes(
        values[fields.allocationType]
      ) && (
        <>
          <Field
            isRequired
            name={fields.allocationSubType}
            label="Allocation Sub Type"
            noLabelTransform
            autoComplete="off"
            selectedValue={values[fields.allocationSubType]}
            onChange={(value) => setFieldValue(fields.allocationSubType, value)}
            options={
              values[fields.feeType] == 2
                ? allocationSubTypeOptionsPercentageInvestmentBased
                : allocationSubTypeOptionsPercentage
            }
            disabled={isEdit && !isSave}
            component={FieldButtonGroup}
            size="md"
            // validate={(value) => {
            //   return [undefined, null, ""].includes(value)
            //     ? "Required"
            //     : undefined;
            // }}
          />

          {values[fields.allocationSubType] === 2 && (
            <Field
              isRequired
              name={fields.participantAllocation}
              label="Participant allocation"
              autoComplete="off"
              selectedValue={values[fields.participantAllocation]}
              onChange={(value) =>
                setFieldValue(fields.participantAllocation, value)
              }
              options={participantAllocationOptions}
              disabled={isEdit && !isSave}
              component={FieldButtonGroup}
              size="md"
              // validate={(value) => {
              //   return [undefined, null, ""].includes(value)
              //     ? "Required"
              //     : undefined;
              // }}
            />
          )}
        </>
      )}
      {values[fields.allocationType] === allocationTypeEnum.Tiered && (
        <>
          <Field
            isRequired
            name={fields.tierComputationSubType}
            label="Tier Computation Type"
            noLabelTransform
            autoComplete="off"
            selectedValue={values[fields.tierComputationSubType]}
            onChange={(value) =>
              setFieldValue(fields.tierComputationSubType, value)
            }
            options={tierComputationSubTypeOptions}
            disabled={isEdit && !isSave}
            component={FieldButtonGroup}
            size="md"
          />

          {values[fields.allocationType] === 3 &&
            values[fields.tierComputationSubType] === 2 && (
              <Field
                isRequired
                name={fields.formulaType}
                noLabelTransform
                label="Percentage / Basis Points"
                autoComplete="off"
                selectedValue={values[fields.formulaType]}
                onChange={(value) => setFieldValue(fields.formulaType, value)}
                options={formulaTypeOptions}
                disabled={isEdit && !isSave}
                component={FieldButtonGroup}
                size="md"
                // validate={(value) => {
                //   return [undefined, null, ""].includes(value)
                //     ? "Required"
                //     : undefined;
                // }}
              />
            )}

          <Field
            isRequired
            name={fields.allocationSubType}
            label="Allocation Sub Type"
            noLabelTransform
            autoComplete="off"
            selectedValue={values[fields.allocationSubType]}
            onChange={(value) => setFieldValue(fields.allocationSubType, value)}
            options={
              values[fields.feeType] == 2
                ? allocationSubTypeOptionsPercentageInvestmentBased
                : allocationSubTypeOptionsPercentage
            }
            disabled={isEdit && !isSave}
            component={FieldButtonGroup}
            size="md"
          />
          {values[fields.allocationSubType] === 2 && (
            <Field
              isRequired
              name={fields.participantAllocation}
              label="Participant Allocation"
              noLabelTransform
              autoComplete="off"
              selectedValue={values[fields.participantAllocation]}
              onChange={(value) =>
                setFieldValue(fields.participantAllocation, value)
              }
              options={participantAllocationOptions}
              disabled={isEdit && !isSave}
              component={FieldButtonGroup}
              size="md"
            />
          )}
          <Field
            isRequired
            name={fields.tierComputationType}
            label="Tier computation Sub Type"
            autoComplete="off"
            noLabelTransform
            selectedValue={values[fields.tierComputationType]}
            onChange={(value) =>
              setFieldValue(fields.tierComputationType, value)
            }
            options={tierComputationTypeOptions}
            disabled={isEdit && !isSave}
            component={FieldButtonGroup}
            size="md"
          />
        </>
      )}
      {values[fields.allocationType] === allocationTypeEnum.FixedAmount && (
        <Field
          size="xs"
          isRequired
          label="Fee amount"
          type="text"
          autoComplete="off"
          name={fields.feeAmount}
          value={values[fields.feeAmount]}
          disabled={isEdit && !isSave}
          onChange={handleChange}
          precision={2}
          component={FieldInputDollar}
        />
      )}

      {[allocationTypeEnum.Percentage].includes(
        values[fields.allocationType]
      ) &&
        values[fields.formulaType] &&
        (values[fields.formulaType] === 1 ? (
          <Field
            size="xs"
            label="Fee percentage"
            isRequired
            type="text"
            autoComplete="off"
            onChange={handleChange}
            name={fields.feePercentageOrBasisPoints}
            disabled={isEdit && !isSave}
            value={values[fields.feePercentageOrBasisPoints]}
            precision={2}
            component={FieldInputPercentage}
          />
        ) : (
          <div className="d-flex">
            <Field
              size="xs"
              label="Basis Points"
              isRequired
              type="text"
              autoComplete="off"
              onChange={handleChange}
              disabled={isEdit && !isSave}
              name={fields.feePercentageOrBasisPoints}
              value={values[fields.feePercentageOrBasisPoints]}
              precision={2}
              component={FieldInputBasisPoint}
            />
          </div>
        ))}
      {values[fields.allocationType] === allocationTypeEnum.Tiered &&
        (values[fields.tierComputationSubType] === 1 ||
          (values[fields.tierComputationSubType] === 2 &&
            values[fields.formulaType])) && (
          <>
            <div className="title-text">
              Tiered Fees Based On Participant Balance
              <span
                style={{ marginLeft: "15px" }}
                className="infoIcon"
                onMouseOver={handleMouseOver}
                onMouseOut={handleMouseOut}
              >
                <FontAwesomeIcon icon={faExclamationCircle} />
              </span>
              {isHovering && (
                <p className="fw-500 ft-14">
                  Values in the From column will be counted from the very next
                  decimal of previous row's To value plus the least decimal
                  increment. (Example, if 1st row says 1 to 20,000 and the 2nd
                  row says 20,000 to 40,000, and the least decimal increment is
                  by 8 digits (0.00000001), then the From value for the 2nd row
                  will be considered as 20,000.00000001)
                </p>
              )}
            </div>
            <div className="count-text">
              {get(values, fields.feeTiers, []).length} Tier fees
            </div>
            <TieredFeesTable fields={fields} {...props} />
            {showErr && (
              <div
                style={{
                  display: "block",
                  fontSize: "0.75rem",
                  marginTop: "15px",
                  color: "#ff5050",
                }}
              >
                {"FE064: All Tier levels should be saved to proceed further"}
              </div>
            )}
          </>
        )}
    </>
  );
}

// function InvestmentBasedComponent(props) {
//   const {
//     values,
//     setFieldValue,
//     fields,
//     isMasterSpecification,
//     setValues,
//     handleChange
//   } = props;
//   const onAllocationTypeChange = (value) => {
//     const tempValues = clearFieldValues({
//       values,
//       fieldsToClear: [
//         fields.allocationType,
//         fields.allocationSubType,
//         fields.participantAllocation,
//         fields.tierComputationType,
//         fields.tierBasis,
//         fields.feePercentageOrBasisPoints,
//         fields.feeAmount,
//         fields.tierComputationSubType,
//         fields.formulaType,
//       ],
//     });
//     tempValues[fields.allocationType] = value;
//     setValues(tempValues);
//   };
//   return (
//     <>
//       {isMasterSpecification && (
//         <>
//           <Field
//             size="md"
//             isRequired
//             name={fields.investmentType}
//             options={investmentTypeOptions}
//             value={values[fields.investmentType]}
//             label="Investment type"
//             direction="bottom"
//             popupContent={
//               <SearchableList
//                 label="Investment type"
//                 options={investmentTypeOptions}
//                 onSelect={(value, label) => {
//                   setFieldValue(fields.investmentType, value);
//                 }}
//                 selectedValue={values[fields.investmentType]}
//                 height="250px"
//                 value={values[fields.investmentType]}
//               />
//             }
//             //disabled={isEdit && !isSave}
//             component={FieldDropSide}
//           />
//           <Field
//             size="md"
//             isRequired
//             name={fields.investmentName}
//             options={investmentNameOptions}
//             value={values[fields.investmentName]}
//             label="Investment name"
//             direction="bottom"
//             popupContent={
//               <SearchableList
//                 label="Investment name"
//                 options={investmentNameOptions}
//                 onSelect={(value, label) => {
//                   setFieldValue(fields.investmentName, value);
//                 }}
//                 selectedValue={values[fields.investmentName]}
//                 height="250px"
//                 value={values[fields.investmentName]}
//               />
//             }
//             //disabled={isEdit && !isSave}
//             component={FieldDropSide}
//           />

//           <Field
//             isRequired
//             name={fields.collectOnlyFromThisInvestment}
//             label="Fee to be collected only from this investment"
//             autoComplete="off"
//             selectedValue={values[fields.collectOnlyFromThisInvestment]}
//             onChange={(value) =>
//               setFieldValue(fields.collectOnlyFromThisInvestment, value)
//             }
//             options={yesNoOptions}
//             disabled={isEdit && !isSave}
//             component={FieldButtonGroup}
//             size="md"
//             validate={(value) => {
//               return [undefined, null, ""].includes(value)
//                 ? "Required"
//                 : undefined;
//             }}
//           />
//         </>
//       )}
//       {/* <Field
//         isRequired
//         name={fields.allocationSubType}
//         label="Tier basis"
//         autoComplete="off"
//         selectedValue={values[fields.allocationSubType]}
//         onChange={(value) => setFieldValue(fields.allocationSubType, value)}
//         options={tierBasisOptions}
//         disabled={isEdit && !isSave}
//         component={FieldButtonGroup}
//         size="md"
//         validate={(value) => {
//           return [undefined, null, ""].includes(value) ? "Required" : undefined;
//         }}
//       /> */}
//       <Field
//         isRequired
//         name={fields.allocationType}
//         label="Allocation type"
//         autoComplete="off"
//         selectedValue={values[fields.allocationType]}
//         onChange={onAllocationTypeChange}
//         options={allocationTypeOptions}
//         disabled={isEdit && !isSave}
//         component={FieldButtonGroup}
//         size="md"
//         validate={(value) => {
//           return [undefined, null, ""].includes(value) ? "Required" : undefined;
//         }}
//       />
//       <Field
//         isRequired
//         name={fields.allocationSubType}
//         label="Allocation sub type"
//         autoComplete="off"
//         selectedValue={values[fields.allocationSubType]}
//         onChange={(value) => setFieldValue(fields.allocationSubType, value)}
//         options={allocationSubTypeOptionsPercentage}
//         disabled={isEdit && !isSave}
//         component={FieldButtonGroup}
//         size="md"
//         validate={(value) => {
//           return [undefined, null, ""].includes(value) ? "Required" : undefined;
//         }}
//       />
//       {values[fields.allocationType] === allocationTypeEnum.FixedAmount && (
//         <Field
//           size="xs"
//           isRequired
//           label="Fee amount"
//           type="text"
//           autoComplete="off"
//           name={fields.feeAmount}
//           value={values[fields.feeAmount]}
//           onChange={handleChange}
//           precision={2}
//           component={FieldInputDollar}
//         />
//       )}
//     </>
//   );
// }

function CreateSpecificationInformation(props) {
  const {
    isMasterSpecification,
    onFormSubmit = () => {},
    initialValues,
    feeType,
    fields,
    setFieldValue,
    values,
    setValues,
    handleChange,
    handleSubmit,
    flow = FLOW_TYPES.SAVE,
  } = props;

  const isEdit = flow === FLOW_TYPES.EDIT;
  const isSave = flow === FLOW_TYPES.SAVE;
  // const getAllocationSubTypeOptions = () =>
  //   values[fields.allocationType] === allocationTypeEnum.FixedAmount
  //     ? allocationSubTypeOptions
  //     : values[fields.allocationType] === allocationTypeEnum.Percentage
  //     ? allocationSubTypeOptionsPercentage
  //     : allocationSubTypeOptionsTiered;
  const feeTypeChange = (value) => {
    let updatedValues = clearFieldValues({
      values,
      fieldsToClear: [
        fields.allocationType,
        fields.allocationSubType,
        fields.participantAllocation,
        fields.tierComputationType,
        fields.tierBasis,
        fields.feePercentageOrBasisPoints,
        fields.investmentType,
        fields.investmentName,
        fields.collectOnlyFromThisInvestment,
      ],
    });
    updatedValues[fields.feeType] = value;
    setValues(updatedValues);
  };
  return (
    <Form
      autoComplete="off"
      className="mb-20 mt-10 header-button-form create-specification-form"
      onSubmit={handleSubmit}
    >
      <Field
        isRequired
        name={fields.name}
        label="Specification name"
        size="md"
        type="text"
        className="mt-3"
        autoComplete="off"
        value={values[fields.name]}
        onChange={handleChange}
        disabled={isEdit && !isSave}
        component={FieldInput}
        // validate={(value) => {
        //   return [undefined, null, ""].includes(value) ? "Required" : undefined;
        // }}
      />
      <Field
        name={fields.description}
        label="Specification Description"
        autoComplete="off"
        value={values[fields.description]}
        onChange={handleChange}
        disabled={isEdit && !isSave}
        component={FieldTextarea}
        size="md"
        // validate={(value) => {
        //   return [undefined, null, ""].includes(value) ? "Required" : undefined;
        // }}
      />
      {isMasterSpecification ? (
        <Field
          isRequired
          name={fields.feeType}
          label="Fee type"
          autoComplete="off"
          selectedValue={values[fields.feeType]}
          onChange={feeTypeChange}
          options={feeTypeOptions}
          disabled={isEdit && !isSave}
          component={FieldButtonGroup}
          size="md"
          // validate={(value) => {
          //   return [undefined, null, ""].includes(value)
          //     ? "Required"
          //     : undefined;
          // }}
        />
      ) : (
        <>
          <div className="label-text-spec">Fee type</div>
          <div className="display-text-spec mb-2">
            {feeTypeOptions.find((x) => x.value === values[fields.feeType])
              ?.label ?? "-"}
          </div>
        </>
      )}
      <BalanceAndInvestmentBasedComponent
        {...props}
        isEdit={isEdit}
        isSave={isSave}
      />
    </Form>
  );
}

export default CreateSpecificationInformation;
